import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  baseUrl = environment.baseUrl + 'country';
  baseUrlStates = environment.baseUrl + 'state';
  constructor(private http: HttpClient) { }


  getCountriesList() {
    //console.log(this.baseUrl);
    let result = this.http.get(this.baseUrl); // No typing - returns Observable<any>
    return result;
  }

  // Get countries for dropdown
  getCountries() {
    return this.http.get('/api/countries/dropdown'); // No typing
  }

  // Get states when country changes
  getStatesForCountry(countryId: string) {
    if (countryId === 'US') {
      return this.http.get('/api/states/us/dropdown'); // No typing
    }
    return of([]); // Empty array for non-US countries
  }

    // Get states when country changes
  getStatesList() {
    return this.http.get(`${this.baseUrlStates}/us/dropdown`);
  }
  
  // Validate state input
  validateState(stateCode: string, countryId: string) {
    const request = { stateCode, countryId };
    return this.http.post('/api/states/validate', request); // No typing
  }


}
